export default class GlassUnit {
    constructor(glassUnit) {
        this.id = glassUnit.id;
        this.field = glassUnit.field;
        this.width = glassUnit.width;
        this.height = glassUnit.height;
        this.has_shape = glassUnit.has_shape;
        this.has_bars = glassUnit.has_bars;
        this.type = glassUnit.type;
        this.description = glassUnit.description;
        this.shape = glassUnit.shape;
        this.barcode = glassUnit.barcode;
        this.product_id = glassUnit.product_id;
        this.created_at = glassUnit.created_at;
        this.updated_at = glassUnit.updated_at;
        this.highlighted = false;
    }

    highlight() {
        this.highlighted = true;
    }

    removeHighlight() {
        this.highlighted = false;
    }
}